module.exports = __webpack_public_path__ + "img/DW365-250.e390dc5a.jpg";